import { render, staticRenderFns } from "./TeamMemberSearch.vue?vue&type=template&id=542987e1&scoped=true&"
import script from "./TeamMemberSearch.vue?vue&type=script&lang=ts&"
export * from "./TeamMemberSearch.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMemberSearch.vue?vue&type=style&index=0&id=542987e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542987e1",
  null
  
)

export default component.exports